import React, { useState, useEffect } from "react";
import { ArrowRight, Play } from "lucide-react";
import "./Hero.css";

function Hero() {
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    let rafId = null;
    const handleScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        setOffsetY(window.scrollY);
        rafId = null;
      });
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  const scrollToQuotes = () => {
    const quotesSection = document.getElementById("quotes");
    if (quotesSection) {
      quotesSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero" id="inicio">
      {/* Animated Background */}
      <div 
        className="hero-bg-animated" 
        style={{ transform: `translateY(${offsetY * 0.5}px)` }}
      ></div>

      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-badge">
            <span className="badge-dot"></span>
            <span className="badge-text">SOLUCIONES METALÚRGICAS LÍDERES</span>
          </div>

          <h1 className="hero-title">
            Estructuras Metálicas y Equipos Industriales en
            <span className="hero-highlight"> Paraguay</span>
          </h1>

          <p className="hero-description">
            Estructuras metálicas y equipos electromecánicos diseñados con simulación y análisis de ingeniería avanzada para máxima durabilidad y rendimiento industrial.
          </p>

          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={scrollToQuotes}>
              <span>Solicitar Cotización</span>
              <ArrowRight size={20} />
            </button>
            <button className="btn btn-secondary">
              <Play size={20} />
              <span>Ver Portafolio</span>
            </button>
          </div>

          <div className="hero-stats">
            <div className="stat">
              <div className="stat-number">100%</div>
              <div className="stat-label">Simulación Estructural</div>
            </div>
            <div className="stat">
              <div className="stat-number">30+</div>
              <div className="stat-label">Proyectos Bien Planificados</div>
            </div>
            <div className="stat">
              <div className="stat-number">ISO</div>
              <div className="stat-label">Estándares de Calidad</div>
            </div>
          </div>
        </div>

        {/* LOGO METSIM - NUEVO */}
        <div className="hero-visual">
          <div className="hero-image-container">
            <img
              src="https://res.cloudinary.com/dk6wclcew/image/upload/f_auto,q_auto,w_900/v1775063931/metsim_logo-1_wrsnco.png"
              alt="METSIM Solutions — Fabricación de estructuras metálicas y equipos industriales en Paraguay"
              className="hero-image logo-image"
              onError={(e) => {
                console.error("Error cargando logo hero:", e);
                e.target.style.opacity = "0.5";
              }}
            />
            <div className="hero-image-glow"></div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <div className="scroll-dot"></div>
        <p>Desplázate para explorar</p>
      </div>
    </section>
  );
}

export default Hero;